import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../AppContext'; // adjust path if needed


const Breadcrumb = (props) => {
    const { appState } = useContext(AppContext);
    const {
        title = 'Finance',
        header = 'Home',
        subHeader = 'Finance',
        image = "https://varefiles.s3.us-east-2.amazonaws.com/meetingpic2.jpg"
    } = appState?.finance;

    if (!title) {
        return
    }
    return (
        <div className="p-relative"
            style={{
                display: 'flex',
                paddingLeft: 40,
                backgroundImage: `url(${image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                zIndex: 1,
                alignItems: 'center',
                minHeight: 400
            }}

        >
            <div className="overlay overlay-bg-black" />
            <div className="pattern" />
            <div className="section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="sub-header-content p-relative">
                                <h1 className="text-custom-white lh-default fw-600">{title}</h1>
                                <div className="custom" style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    gap: 10
                                }}>
                                    <div>
                                        <div to="/" className="text-custom-white">{header}</div>
                                    </div>
                                    |
                                    <div className="text-custom-white active">{subHeader}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Breadcrumb;
